import React, { useEffect } from 'react';
import { GalleryPage } from '../GalleryComponents/GalleryPage';
import Logo from '../assets/Logo/mainlogo.png';

export const Gallery = () => {
    useEffect(() => {
        // Set the id of the body element when the component mounts
        document.body.id = 'GalleryBody';
        // Remove the id when the component unmounts
        return () => {
            document.body.id = '';
        };
    }, []);

    return (
        <div>
            <nav className="navbar-revamp">


                <ul className="nav-links-revamp">
                    <li><a href="/">Home</a></li>
                    <li><a href="/Gallery">Gallery</a></li>
                    <li><a href="/Charters">Charters</a></li>
                    <li><a href="/#about" >About Us</a></li>

                </ul>
                <div className="logo-container-revamp">
                    <img
                        src={Logo}
                        alt="EPIC Texas Charters Logo"
                        className="logo-revamp"
                    />
                </div>

                <div className="nav-button-revamp">
                   <a href='#footer' > <button>Contact Us</button></a>
                </div>
            </nav>


            <GalleryPage />
        </div>
    );
};

export default Gallery;
